// extracted by mini-css-extract-plugin
module.exports = {"recommendations":"Recommendations_recommendations__1Vu_9","recommendation":"Recommendations_recommendation__xYhM-"};